import classNames from 'classnames';
import './StatValue.scss';

interface StatValueProps {
    className?: string;
    children?: React.ReactNode;
    unit?: string;
}

export function StatValue({ children, unit, className }: StatValueProps) {
    if (children == null) return null;

    return (
        <h5 className={classNames(className, 'StatValue')}>
            {children} <sup>{unit}</sup>
        </h5>
    );
}
